<template>
<div id="appallegato" class="mx-auto" style="width: 95%;margin-top:15px;" v-cloak>

    <b-container fluid>

        <b-row>
            <b-col sm="6" md="4" lg="3" class="mx-auto text-center">

                <b-carousel v-if="showCarousel" id="carousel" style="text-shadow: 1px 1px 2px #333;" :interval="0" controls indicators background="#ababab" img-width="200px" img-height="200px">

                    <!--La prima immagine finta ci vuole per non creare errori al caricamento pagina-->
                    <!-- <b-carousel-slide v-if="showFirst" img-src="">
                            </b-carousel-slide> -->
                    <!-- -->

                    <b-carousel-slide :key="item.id" v-for="item in itemsImage" :img-src="item.allegato" img-width="200px" img-height="200px">
                    </b-carousel-slide>
                </b-carousel>

            </b-col>
        </b-row>

        <b-row>
            <b-col sm="12" class="mx-auto text-center">

                <b-card :header="'Allegati ' + getDescTipo(this.$route.params.tipo).toLowerCase() + ' #' + this.$route.params.id" class="mx-auto text-center">
                    <div v-if="showtable" class="text-left">

                        <div class="my-1 row">
                            <div class="col-md-3">
                                <b-form-input v-model="filter" placeholder="Cerca..." />
                            </div>
                            <div class="col-md-9 text-right">
                                <b-button size="md" variant="outline-primary" @click.stop="insert()">
                                    Inserisci
                                </b-button>
                            </div>
                        </div>

                        <!-- Main table element -->
                        <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                            <template slot="id" scope="row">{{row.value}}</template>
                            <template slot="allegatoVis" scope="row">{{row.value}}</template>

                            <template slot="modifica" scope="row">
                                <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                                <b-btn style="margin:0px 0px 1px 2px;" variant="warning" size="sm" @click.stop="del(row.item,row.index,$event.target)">Elimina</b-btn>
                                <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details(row.item,row.index,$event.target)">Visualizza</b-btn>
                            </template>

                        </b-table>

                        <div class="row my-1">
                            <div class="col-md-8 col-sm-12">
                                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                            </div>
                            <div class="col-md-4 col-sm-12 text-right">
                                <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                                    <b-form-select :options="pageOptions" v-model="perPage" />
                                </b-form-fieldset>
                            </div>
                        </div>
                    </div>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

                </b-card>

            </b-col>
        </b-row>        

    </b-container>

    <!-- Modal Component -->
    <b-modal v-model="deleteModal.show" title="Elimina">
        <p class="my-2">Confermi l'eliminazione dell'allegato #{{deleteModal.id}}: {{deleteModal.nominativo}}?</p>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="delItem()" style="margin: 2px;">
                Conferma
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="deleteModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>

    <!-- Modal Component Upload -->
    <b-modal v-model="uploadModal.show" title="Seleziona il file da inserire" @hidden="onHidden">
        <!-- <p class="my-2">Seleziona il file da inserire</p> -->
        <b-btn id="browse" ref="browse" size="md" variant="primary">Sfoglia...</b-btn>
        <h5>{{uploadModal.descrCaricamento}}</h5>
        <b-progress v-if="uploadModal.showPercent" :value="uploadModal.percentCaricamento" :max="100" show-progress animated></b-progress>
        <b-alert style="margin-top:10px;" :show="(uploadModal.errorCaricamento != '')" variant="danger">{{ uploadModal.errorCaricamento }}</b-alert>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="caricaItem()" style="margin: 2px;">
                Inserisci
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="uploadModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>

</div>
</template>

<script>
import {
    NAMESPACE,
    TOKENUPLOAD
} from '../config.js'

import {
    uuidv4,
    ctrlVismenu
} from '../util.js'

import {
    Categoria
} from '../classes.js'

import {
    Resumable
} from '../resumable.js'

export default {
    name: 'appallegato',
    data: function () {
        return {

            r: new Resumable({
                target: '',
                testChunks: true
            }),

            id: this.$route.params.id,
            tipo: this.$route.params.tipo,
            items: [],
            itemsImage: [],
            slide: 0,
            sliding: null,
            //showFirst: true,
            showCarousel: false,
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                allegatoVis: {
                    label: 'Allegato',
                    sortable: true
                },
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },
            deleteModal: {
                id: null,
                nominativo: '',
                show: false
            },
            uploadModal: {
                show: false,
                descrCaricamento: '',
                showPercent: false,
                percentCaricamento: 0,
                errorCaricamento: '',
                uuidv4: ''
            },
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,
            modalDetails: {
                index: '',
                data: ''
            },
            error: '',
            showerror: false,
            showtable: false
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    methods: {
        caricaDati(id, tipo){

            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + 'rest/allegati/id_scheda/' + this.id + '/tipo/' + this.tipo, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            this.items = response.data.message;
                            let apptable = this;

                            apptable.items.forEach(function(element, index) {
                                var split = element.allegato.split('/');
                                element.allegatoVis = decodeURI(split[split.length - 1]);
                            });


                            apptable.itemsImage = response.data.message.slice(0); //clono l'array

                            for (var i = 0; i < apptable.itemsImage.length; i++) {
                                var split = apptable.itemsImage[i].allegato.split('.');
                                var extfile = (split[split.length - 1]).toLowerCase();
                                var extarray = ["tif", "gif", "png", "bmp", "jpg", "jpeg"];
                                if (extarray.indexOf(extfile) == -1) {
                                    apptable.itemsImage.splice(i, 1);
                                    i--;
                                }
                            }

                            apptable.showCarousel = (apptable.itemsImage.length > 0);
                            apptable.showtable = true;

                        } else {
                            throw new Error(response.data.message);
                        }

                    } catch (e) {
                        this.showerror = true;
                        this.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    this.showerror = true;
                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });
        },
        onHidden(evt) {
            this.r.cancel();
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        onSlideStart(slide) {
            this.sliding = true;
        },
        onSlideEnd(slide) {
            this.sliding = false;
        },
        getDescTipo(tipo) {
            var cat = new Categoria();
            return cat.getTipoByFlag(tipo);
        },
        del(item, index, button) {
            this.deleteModal.id = item.id;
            this.deleteModal.nominativo = item.allegatoVis;
            this.deleteModal.show = true;
        },
        details(item, index, button) {
            window.open(item.allegato, '_blank');
        },
        insert() {

            this.uploadModal.showPercent = false;
            this.uploadModal.descrCaricamento = '';
            this.uploadModal.percentCaricamento = 0;
            this.uploadModal.errorCaricamento = '';
            this.uploadModal.show = true;
            this.uploadModal.uuidv4 = uuidv4();

            this.$nextTick(() => {
                this.prepareUpload();
            });

        },
        caricaItem() {
            if (this.r.files.length == 0) {
                alert("Nessun file selezionato!");
            } else {
                this.r.opts.target = NAMESPACE + 'rest/upload.php?id=' + this.uploadModal.uuidv4 + '&tokenupload=' + TOKENUPLOAD;
                this.uploadModal.showPercent = true;
                this.r.upload();               
                
            }
        },
        delItem() {

            var apptable = this;

            var token = localStorage.getItem('token');
            this.axios.delete(NAMESPACE + 'rest/allegati/' + this.deleteModal.id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            //forse può essere fatta diversamente e meglio
                            for (var i = 0; i < apptable.items.length; i++) {
                                if (this.items[i].id == this.deleteModal.id) {
                                    this.items.splice(i, 1); //delete
                                    break;
                                }
                            }
                            this.deleteModal.show = false;

                        } else {
                            throw new Error(response.data.message);
                        }

                    } catch (e) {

                        this.deleteModal.show = false;
                        apptable.showerror = true;
                        apptable.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {

                    this.deleteModal.show = false;
                    apptable.showerror = true;
                    apptable.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },
        prepareUpload() {  

                //non rimuovere serve per resettare l'oggetto a ogni caricamento
                //altrimenti carica i file duplicandoli
                this.r = new Resumable({
                    target: '',
                    testChunks: true
                });

                this.r.assignBrowse(this.$refs.browse, false);

                var rg = this.r;
                var appallegato = this;

                this.r.on('fileAdded', function(file, event) {
                    rg.files = rg.files.slice(-1); //prendo sempre solo l'ultimo file    
                    
                    //alert("fileAdded: ");

                    //ATTENZIONE: non cambiare è come se fosse una funzione esterna e quindi il this qui non funzionerebbe
                    appallegato.uploadModal.descrCaricamento = file.fileName;

                });

                this.r.on('fileSuccess', function(file, message) {
                    try {

                        //alert("fileSuccess: " + message.trim());

                        var res = JSON.parse(message.trim());

                        if (!res.error) {
                            appallegato.uploadModal.percentCaricamento = 100;

                            var json = JSON.stringify({
                                'id': null,
                                'id_scheda': appallegato.id,
                                'tipo': appallegato.tipo,
                                's3': res.message.s3,
                                'allegato': encodeURI(appallegato.uploadModal.uuidv4 + '/' + file.fileName)
                            });

                            var token = localStorage.getItem('token');
                            appallegato.axios.post(NAMESPACE + 'rest/allegato', json, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': token
                                    }
                                })
                                .then(response => {

                                    // JSON responses are automatically parsed.
                                    try {

                                        if (!response.data.error) {

                                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                            appallegato.caricaDati(appallegato.id, appallegato.tipo);
                                            setTimeout(function() {
                                                appallegato.uploadModal.show = false;
                                            }, 1000);

                                        } else {
                                            throw new Error(response.data.message);
                                        }


                                    } catch (e) {
                                        throw new Error(e.message);
                                    }

                                })
                                .catch(e => {
                                    throw new Error((e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message));
                                });




                        } else {
                            throw new Error(res.message);
                        }

                    } catch (e) {
                        appallegato.uploadModal.errorCaricamento = "Errore: " + e.message;
                    }

                });

                this.r.on('progress', function() {
                    appallegato.uploadModal.percentCaricamento = rg.progress() * 100;
                    //alert("Perc car " + appallegato.uploadModal.percentCaricamento);
                    //FORZATURA NON BELLA
                    if (rg.progress() * 100 === 100) {
                        setTimeout(function() {
                            appallegato.uploadModal.show = false;
                        }, 1000);
                    }


                });

                this.r.on('error', function(message, file) {
                    appallegato.uploadModal.errorCaricamento = message;
                    //alert("Errore message " + message);
                    //alert("Errore file " + file);
                });

        }
    },
    created: function () {

           
        
        if(!ctrlVismenu("E")&&!ctrlVismenu("I")&&!ctrlVismenu("B")&&!ctrlVismenu("C")&&!ctrlVismenu("N")&&!ctrlVismenu("D")){
            this.$router.replace('/accessdenied');
            return;
        }

        this.caricaDati(this.id, this.tipo);

    }
}
</script>
